const STORAGE_KEY = "relock.proPreview";
const PARAM = "pro";

// Пока оплата не запущена, всё платное (пункт Pro в меню, «Тарифы» и реквизиты в подвале) видно
// только тем, кто пришёл по ссылке с `?pro=1`: модерации платёжного сервиса и команде. Метка
// запоминается в браузере, `?pro=0` её снимает. Хранилище недоступно — платного не видно.
export const captureProPreview = (
  location: Location = window.location,
  storage: Storage = window.localStorage,
): void => {
  try {
    const value = new URL(location.href).searchParams.get(PARAM);
    if (value === null) {
      return;
    }
    if (value === "0") {
      storage.removeItem(STORAGE_KEY);
    } else {
      storage.setItem(STORAGE_KEY, "1");
    }
  } catch {
    // Без хранилища — без платного.
  }
};

export const isProPreview = (storage: Storage = window.localStorage): boolean => {
  try {
    return storage.getItem(STORAGE_KEY) === "1";
  } catch {
    return false;
  }
};
